import React from 'react'

import styled from 'styled-components/native'

import { Display } from '../../../atoms/display/Display'
import { DisplaySize } from '../../../styles/typeStyles'

export type ClientFiltersSectionProps = {
  title: React.ReactNode
}

const Container = styled.View(({ theme }) => ({
  gap: theme.spacing['8px'],
}))

export const ClientFiltersSection: React.FC<React.PropsWithChildren<ClientFiltersSectionProps>> = ({
  title,
  children,
}) => {
  return (
    <Container>
      <Display size={DisplaySize.EYEBROW} text={title} />
      {children}
    </Container>
  )
}
